let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dDH4y")).then(() => parcelRequire('bx3ZD'));